import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { BrokerTransactionApprovalComponent } from './broker-transaction-approval/broker-transaction-approval.component';
import { AuthGuard } from '../../shared/security/auth.guard';
import { BrokerSubmitPendingApprovalsComponent } from './broker-submit-pending-approvals/broker-submit-pending-approvals.component';
import { FormsModule } from '@angular/forms';
import { PTLSharedModule } from '../../shared/shared.module';
import { NgxPrintModule } from 'ngx-print';
import { BrokerTransactionApprovalService } from './broker-transaction-approval.service';
import { IndividualLicenseComponent } from './individual-license/individual-license.component';
import { IndividualLicenseService } from './individual-license.service';

const routes: Routes = [
  { path: 'pendingApprovals', component: BrokerTransactionApprovalComponent, canActivate: [AuthGuard]},
  { path: 'submitPendingApprovals', component: BrokerSubmitPendingApprovalsComponent, canActivate: [AuthGuard]}
 

];
@NgModule({
  imports: [
    CommonModule,RouterModule.forChild(routes), FormsModule, PTLSharedModule, NgxPrintModule
  ],
  
  declarations: [ BrokerTransactionApprovalComponent, BrokerSubmitPendingApprovalsComponent, IndividualLicenseComponent],
  providers :[BrokerTransactionApprovalService,IndividualLicenseService],
  entryComponents: [IndividualLicenseComponent]
})
export class ViewPendingApprovalsModule { }



// WEBPACK FOOTER //
// ./src/app/broker/view-pending-approvals/view-pending-approvals.module.ts